// ترجماتُ المجموعة 5 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B5: Record<string, string> = {
  "فتح في خرائط جوجل": "Open in Google Maps",
  "جهة اتصال": "Contact",
  "بانتظار": "Waiting",
  "فتح محادثة": "Open chat",
  "الرقم محفوظ أصلاً باسم «{name}»": "Number already saved as “{name}”",
  "الرقم محفوظ أصلاً": "Number already saved",
  "تعذر الحفظ": "Couldn't save",
  "حُفظ في جهات الاتصال": "Saved to contacts",
  "حفظ الرقم": "Save number",
  "يدويّ": "Manual",
  "— اختر العقد —": "— Select contract —",
  "متبقٍّ": "remaining",
  "رد مقترح": "Suggested reply",
  "إخفاء": "Hide",
  "يكتب الذكاء ردّاً مقترحاً…": "AI is writing a suggested reply…",
  "تعذّر اقتراح رد": "Couldn't suggest a reply",
  "أعد المحاولة": "Try again",
  "استخدم": "Use",
  "اقتراح آخر": "Another suggestion",
  "رابط دفع": "Payment link",
  "المستحق حالياً": "Currently due",
  "نظام التأجير لا يرسل مبالغ": "The rental system doesn't send amounts",
  "عدد العقود": "Contracts",
  "العقد النشط": "Active contract",
  "قيمة العقد": "Contract value",
  "العقود السابقة": "Previous contracts",
  "لا توجد صور أو فيديو لهذه السيارة": "No photos or videos for this vehicle",
  "عنصر": "items",
  "اختر ملفات للإرسال": "Select files to send",
  "عنصر محدد": "items selected",
  "كشف عمولة": "Commission statement",
  "كشف عمولة الموظف:": "Employee commission statement:",
  "رمز": "Ref",
  "الفترة من": "Period from",
  "نسبة العمولة": "Commission rate",
  "تاريخ التأجير": "Rental date",
  "قيمة العقد (د.ك)": "Contract value (KWD)",
  "المحصَّل بشهر العقد (د.ك)": "Collected in contract month (KWD)",
  "العمولة (د.ك)": "Commission (KWD)",
  "لا توجد عقود في الفترة": "No contracts in this period",
  "العمولة تُحتسب على المبلغ المحصَّل من العقد خلال نفس شهر إنشائه فقط (سندات القبض الفعلية من Drive8).": "Commission is calculated only on the amount collected from the contract within the month it was created (actual receipts from Drive8).",
  "توقيع الموظف: ______________": "Employee signature: ______________",
  "اعتماد المدير: ______________": "Manager approval: ______________",
  "إعادة عمولة العقد {n}؟": "Restore the commission for contract {n}?",
  "سبب إلغاء عمولة التوصيل (يصل الموظّف):": "Reason for voiding the delivery commission (sent to the employee):",
  "تعذّر التنفيذ": "Action failed",
  "مبلغ غير صالح": "Invalid amount",
  "تم الحفظ ✓": "Saved ✓",
  "حذف الموظف من قائمة العمولات؟ (عقوده تبقى في Drive8، فقط يخرج من الكشوفات)": "Remove this employee from the commissions list? (Their contracts stay in Drive8; they're only removed from statements.)",
  "لا تملك صلاحية عرض هذه الصفحة": "You don't have permission to view this page",
  "عمولات وأداء موظفي التأجير": "Rental Staff Commissions & Performance",
  "لا توجد عقود لموظفي العمولات في هذه الفترة — تأكد من أكواد Drive8 في تبويب «الموظفون»": "No contracts for commission employees in this period — check the Drive8 codes in the “Employees” tab",
  "نسبة": "Rate",
  "محصَّل": "Collected",
  "عمولة": "Commission",
  "🖨 طباعة الكشف": "🖨 Print statement",
  "المحصَّل بشهر العقد": "Collected in contract month",
  "العمولة": "Commission",
  "العمولة = نسبة الموظف × المحصَّل من العقد خلال نفس شهر إنشائه فقط (من سندات القبض الفعلية).": "Commission = employee rate × amount collected from the contract within the month it was created only (from actual receipts).",
  "ما يُحصَّل في شهر لاحق لا يدخل العمولة. العقود تُنسب لمن أنشأها بكود Drive8، والتمديد لا يُنشئ عقداً جديداً.": "Amounts collected in a later month don't count. Contracts are attributed to whoever created them by Drive8 code, and an extension doesn't create a new contract.",
  "ملغاة": "Voided",
  "وصّلوا ولا تُحتسب لهم عمولة": "Delivered but earn no commission",
  "لأنّهم غير مربوطين بصفٍّ في «الموظفون»:": "because they aren't linked to a row in “Employees”:",
  "اربط كلَّ واحدٍ منهم بحقل «موظّف جسر» في تبويب «الموظفون» ليدخل الكشف.": "Link each of them via the “Jisr employee” field in the “Employees” tab to include them in the statement.",
  "رفعاتٌ تنتظر الاعتماد — لا تدفع بعد": "Uploads awaiting approval — not paid yet",
  "(العمولة تُصرف بعد الاعتماد؛ اعتمدها من «التسليم والاستلام» لتدخل الكشف)": "(Commission is paid after approval; approve it from “Delivery & Return” to include it in the statement)",
  "منذ": "for",
  "لا توصيلات في هذه الفترة — التوصيلة تُحتسب لمن رفع فيديو التسليم": "No deliveries in this period — a delivery is credited to whoever uploaded the delivery video",
  "د.ك للتوصيلة": "KWD per delivery",
  "توصيلة": "deliveries",
  "تاريخ التسليم": "Delivery date",
  "✕ أُلغيت العمولة": "✕ Commission voided",
  "مَن وصّل السيّارة = مَن رفع فيديو التسليم. تُحتسب": "Whoever delivered the car = whoever uploaded the delivery video. Credited",
  "بالرفع": "on upload",
  "لا بالاعتماد (والمرفوضُ لا يُحتسب: رُفض = لم تقع؛ والمُرجَعُ للتعديل يبقى) — العمل وقع حين ذهب ووصّل وصوّر، ومراجعةُ الفيديو شأنُ المكتب. ومرّةً واحدة لكلّ عقدٍ مهما تكرّر الرفع (لأقدم رفعة). والاستلام لا عمولة له.": "not on approval (rejected uploads don't count: rejected = didn't happen; ones returned for edits still count) — the work was done when they went, delivered and filmed; reviewing the video is the office's job. Once per contract no matter how many uploads (the earliest one counts). Returns earn no commission.",
  "د.ك هذا الشهر": "KWD this month",
  "عن الشهر الماضي": "vs last month",
  "الشهر الماضي:": "Last month:",
  "المحصَّل شهرياً لكل موظف (آخر 12 شهر) — للتقييم السنوي": "Monthly collections per employee (last 12 months) — for annual review",
  "الشهر": "Month",
  "المجموع": "Total",
  "إجمالي السنة": "Year total",
  "الأرقام = المحصَّل من عقود الموظف خلال شهر إنشائها (نفس أساس العمولة)، وبين الأقواس عدد العقود.": "Figures = amount collected from the employee's contracts within their creation month (same basis as commission); contract count in brackets.",
  "مصاريف الإعلانات (د.ك)": "Ad spend (KWD)",
  "عقود جديدة في": "New contracts in",
  "الإيراد المحصَّل من عقود الشهر (د.ك)": "Revenue collected from the month's contracts (KWD)",
  "COR — د.ك إيراد لكل 1 د.ك إعلانات": "COR — KWD revenue per 1 KWD of ads",
  "آخر 12 شهر": "Last 12 months",
  "عقود جديدة": "New contracts",
  "الإيراد المحصَّل": "Revenue collected",
  "الإعلانات": "Ads",
  "COR = الإيراد المحصَّل من عقود الشهر (خلال شهرها) ÷ مصاريف الإعلانات — مثال: 8,500 ÷ 940 = 9.05 د.ك لكل دينار إعلانات.": "COR = revenue collected from the month's contracts (within that month) ÷ ad spend — e.g. 8,500 ÷ 940 = 9.05 KWD per dinar of ads.",
  "يوم قطع دورة الراتب": "Payroll cycle cut-off day",
  "حُفظ يوم القطع": "Cut-off day saved",
  "تعذّر الحفظ": "Couldn't save",
  "الدورة تبدأ هذا اليوم من كلّ شهر وتنتهي قبله من الشهر التالي — مثلاً": "The cycle starts on this day each month and ends the day before in the next month — e.g.",
  "والموظّف يرى مجموعَ عمولاته لهذه الدورة في شاشة الحضور بالتطبيق.": "Employees see their commission total for this cycle on the attendance screen in the app.",
  "موظّف جسر (للتوصيل)": "Jisr employee (for deliveries)",
  "— بلا ربط —": "— Not linked —",
  "+ إضافة": "+ Add",
  "كود Drive8 (منشئ العقد)": "Drive8 code (contract creator)",
  "رمز الموظف": "Employee ref",
  "النسبة ٪": "Rate %",
  "عمولة التوصيل": "Delivery commission",
  "فعّال": "Active",
  "لا يوجد موظفون بعد — أضف أول موظف من الأعلى": "No employees yet — add the first one above",
  "«كود Drive8» هو كود المستخدم الذي يُسجَّل على العقد عند إنشائه في Drive8 — لازم يطابقه حرفياً. الموظف غير الفعّال يبقى محفوظاً لكن يختفي من الكشوفات.": "“Drive8 code” is the user code recorded on the contract when it's created in Drive8 — it must match exactly. Inactive employees stay saved but are hidden from statements.",
  "و«موظّف جسر» هو حسابُه في التطبيق — منه نعرف مَن رفع فيديو التسليم فتُحتسب له عمولةُ التوصيل. من لا يوصّل لا يحتاجه.": "“Jisr employee” is their account in the app — it tells us who uploaded the delivery video so the delivery commission is credited to them. Not needed for staff who don't deliver.",
  "و": "And ",
  "المندوب لا كودَ Drive8 له": "a courier has no Drive8 code",
  "(لا ينشئ عقوداً) — اتركه فارغاً واربطه بموظّف جسر فقط، فيدخل «عمولات التوصيل» ولا يظهر في كشف العمولات. ولا بدّ من أحدهما: صفٌّ بلا كودٍ ولا ربطٍ لا يكسب شيئاً في أيّ كشف.": "(they don't create contracts) — leave it blank and only link a Jisr employee, so they appear in “Delivery commissions” but not in the commission statement. One of the two is required: a row with neither a code nor a link earns nothing in any statement.",
  "موظّف": "Employee",
  "محذوف": "deleted",
  "أُعيدت العمولة": "Commission restored",
  "أُلغيت العمولة وأُبلغ الموظّف": "Commission voided and the employee notified",
  "تعود العمولة إلى الموظّف ويصله إشعار": "The commission goes back to the employee and they're notified",
  "تسقط العمولة ويصل الموظّفَ السبب — والفيديو لا يُمسّ": "The commission is dropped and the employee receives the reason — the video is untouched",
  "↺ إعادة": "↺ Restore",
  "✕ إلغاء": "✕ Void",
  "الرحلات والتوصيل": "Trips & Delivery",
  "طلبات النقل من نقطة إلى نقطة — إسناد، تتبع، وصول بالسياج، وأداء السائقين": "Point-to-point transport orders — assignment, tracking, geofenced arrival and driver performance",
  "جارية الآن": "In progress",
  "بلا إسناد": "Unassigned",
  "مكتملة": "Completed",
  "وصول متأخر": "Late arrivals",
  "كل الطلبات المفتوحة": "All open orders",
  "طلب جديد": "New order",
  "لا طلبات.": "No orders.",
  "غير مُسند": "Unassigned",
  "حدّد تاريخ ووقت الاستلام": "Set the pickup date and time",
  "طلب نقل جديد": "New transport order",
  "اسم العميل / الراكب": "Customer / passenger name",
  "يصله تأكيد الحجز ورابط التتبع": "Receives the booking confirmation and tracking link",
  "وقت الاستلام": "Pickup time",
  "نقطة الاستلام (A) — العنوان": "Pickup point (A) — address",
  "المنزل — الجابرية ق1…": "Home — Jabriya Block 1…",
  "موقع الاستلام": "Pickup location",
  "اختر على الخريطة أو الصق رابط خرائط جوجل — مطلوب للتحقق بالسياج": "Pick on the map or paste a Google Maps link — required for geofence verification",
  "الوجهة (B) — العنوان": "Destination (B) — address",
  "مستشفى…": "Hospital…",
  "موقع الوجهة": "Destination location",
  "متطلبات الراكب": "Passenger requirements",
  "كرسي متحرك، مرافق…": "Wheelchair, companion…",
  "— لاحقاً —": "— Later —",
  "بلا رقم": "no number",
  "السيارة (متتبَّعة)": "Vehicle (tracked)",
  "لا سيارات مربوطة بجهاز تتبع": "No vehicles linked to a tracking device",
  "باختيار السائق يصير الطلب «مُسند» ويصل السائق إشعار على الواتساب ليقبل من «رحلاتي». السيارة المتتبَّعة اختيارية — بدونها لا يظهر موقع السيارة في رابط العميل.": "Choosing a driver makes the order “Assigned” and the driver gets a WhatsApp notification to accept it from “My Trips”. The tracked vehicle is optional — without it the vehicle's location won't appear on the customer's link.",
  "الخريطة": "Map",
  "رابط خرائط جوجل أو 29.37, 47.97": "Google Maps link or 29.37, 47.97",
  "المتصفح لا يدعم تحديد الموقع": "Your browser doesn't support location",
  "تعذّر تحديد موقعك — اسمح للمتصفح بالوصول للموقع": "Couldn't get your location — allow the browser to access your location",
  "ما لقيت المكان — جرّب بالإنجليزي (Al Hadi Hospital) أو حرّك الخريطة وحط الدبوس يدوياً": "Place not found — try another spelling (e.g. Al Hadi Hospital) or move the map and drop the pin manually",
  "ابحث: مستشفى الهادي، صباح الناصر…": "Search: Al Hadi Hospital, Sabah Al Nasser…",
  "موقعي الحالي": "My location",
  "تعذّر تحميل الخريطة — الصق الرابط أو الإحداثيات يدوياً": "Couldn't load the map — paste the link or coordinates manually",
  "المس الخريطة لوضع الدبوس، واسحبه لتعديله": "Tap the map to drop the pin, drag it to adjust",
  "اعتماد الموقع": "Confirm location",
  "الحالة الجديدة": "New status",
  "سبب التجاوز اليدوي (يظهر في السجل):": "Reason for manual override (shown in the log):",
  "الوصول:": "Arrival:",
  "الانتظار:": "Waiting:",
  "تجاوز المهلة": "Grace exceeded",
  "الموعد": "Scheduled",
  "الواتساب": "WhatsApp",
  "متطلبات": "Requirements",
  "وصول مُتحقَّق": "Verified arrival",
  "{n} م من النقطة": "{n} m from the point",
  "السيارة على {n} م": "vehicle at {n} m",
  "موقع السيارة الآن": "Vehicle location now",
  "خرائط ↗": "Maps ↗",
  "سبب الإلغاء": "Cancellation reason",
  "رابط تتبع العميل:": "Customer tracking link:",
  "تعديل البيانات": "Edit details",
  "تذكير انتظار للعميل": "Waiting reminder to customer",
  "تجاوز يدوي للحالة": "Manual status override",
  "لم يحضر": "No-show",
  "إلغاء الطلب": "Cancel order",
  "سجل الأحداث": "Event log",
  "السبب:": "Reason:",
  "(بلا إحداثيات — لا سياج)": "(no coordinates — no geofence)",
  "لا رحلات في هذه الفترة.": "No trips in this period.",
  "«في الوقت/مبكر/متأخر» يُحسب من الوصول المُتحقَّق بالسياج مقارنةً بالموعد حسب إعدادات السماح. «خارج السياج» محاولات تسجيل وصول رُفضت لبعد السائق عن النقطة.": "“On time/Early/Late” is based on the geofence-verified arrival compared to the scheduled time, per the tolerance settings. “Outside geofence” = check-in attempts rejected because the driver was too far from the point.",
  "تسمية الراكب": "Passenger label",
  "المريض / العميل / الشحنة…": "Patient / customer / shipment…",
  "التحقق بالسياج عند الوصول للوجهة أيضاً": "Also verify by geofence on arrival at the destination",
  "رسائل الواتساب للعميل": "Customer WhatsApp messages",
  "المتغيرات:": "Variables:",
  "تُرسل من واتساب الشركة المربوط في جسر.": "Sent from the company WhatsApp connected in Jisr.",
  "سبب تسجيل «لم يحضر»:": "Reason for marking “No-show”:",
  "سبب الإلغاء:": "Cancellation reason:",
  "إعادة إسناد": "Reassign",
  "إسناد": "Assign",
  "جهازك لا يدعم تحديد الموقع": "Your device doesn't support location",
  "{h} س {m} د": "{h}h {m}m",
  "كل الحقول مطلوبة": "All fields are required",
  "تعذّر الدخول": "Couldn't sign in",
  "جسر": "Jisr",
  "تسجيل دخول الموظف": "Employee sign-in",
  "كود الشركة": "Company code",
  "مثال: default": "e.g. default",
  "كود الموظف أو الجوال": "Employee code or mobile",
  "EMP001 أو 9xxxxxxx": "EMP001 or 9xxxxxxx",
  "جارٍ الدخول…": "Signing in…",
  "تعذّر فتح الكاميرا — فعّل إذن الكاميرا للتطبيق ثم حاول.": "Couldn't open the camera — allow camera access for the app and try again.",
  "حضورُك مسجَّلٌ فعلاً — لا حاجةَ لإعادة التسجيل.": "You're already checked in — no need to check in again.",
  "تعذّر التقاط الصورة": "Couldn't capture the photo",
  "تعذّر رفع الصورة": "Couldn't upload the photo",
  "بصمتُك السابقةُ أُغلقت — اضغط مرّةً أخرى لبدء مناوبةٍ جديدة.": "Your previous punch was closed — tap again to start a new shift.",
  "حضورُك مسجَّلٌ فعلاً — هذه إعادةُ إرسالٍ للمحاولة نفسِها، ولم تُسجَّل بصمةٌ ثانية.": "You're already checked in — this was a resend of the same attempt, no second punch was recorded.",
  "أنت خارج نطاق الفرع — بانتظار مراجعة الإدارة.": "You're outside the branch zone — pending management review.",
  "تم تسجيل الحضور ✅": "Checked in ✅",
  "انصرافُك مسجَّلٌ فعلاً — المحفوظ {d}، ولم يُغيَّر وقتُ الخروج.": "You're already checked out — {d} recorded; check-out time unchanged.",
  "تم الانصراف ✅ — ساعات العمل {d}": "Checked out ✅ — worked {d}",
  "موظف": "Employee",
  "حالة اليوم": "Today's status",
  "الدخول": "Check-in",
  "الخروج": "Check-out",
  "ساعات العمل": "Hours worked",
  "تأخير": "Late",
  "📸 تسجيل الحضور بالصورة": "📸 Check in with photo",
  "ثبّت وجهك داخل الإطار ثم اضغط التقاط": "Keep your face inside the frame, then tap Capture",
  "التقاط وتسجيل": "Capture & check in",
  "تسجيل الانصراف": "Check out",
  "أنهيت دوامك اليوم ✅": "You've finished your shift today ✅",
  "ملخّص الشهر": "Month summary",
  "أيام الحضور": "Days present",
  "أيام التأخير": "Late days",
  "تعذّرت قراءة الاستئذان المعتمَد — التأخيرُ لم يُحتسب. راجع الإدارة.": "Couldn't read approved permissions — lateness wasn't counted. Contact management.",
  "آخر السجلات": "Recent records",
  "لا توجد سجلات بعد": "No records yet",
  "يلزم تفعيل الكاميرا و GPS والتواجد داخل نطاق الفرع لتسجيل الحضور.": "Check-in requires the camera, GPS, and being inside the branch zone.",
  "تم رفض إذن الموقع — فعّله من إعدادات التطبيق.": "Location permission denied — enable it in the app settings.",
  "تعذّر تحديد الموقع — تأكد من تشغيل GPS وحاول مجددًا.": "Couldn't get your location — make sure GPS is on and try again.",
  "🚨 منتهية منذ {n} يوم": "🚨 Expired {n} days ago",
  "⚠️ تنتهي بعد {n} يوم — {date}": "⚠️ Expires in {n} days — {date}",
  "سارية حتى {date} (باقي {n} يوم)": "Valid until {date} ({n} days left)",
  "اسم الورقة مطلوب": "Document name is required",
  "تاريخ الانتهاء مطلوب": "Expiry date is required",
  "تعديل «{name}»": "Edit “{name}”",
  "ورقة جديدة": "New document",
  "اسم الورقة *": "Document name *",
  "رخصة تجارية / اشتراك بلدية / تأمين المكتب…": "Trade license / municipality subscription / office insurance…",
  "رقم الورقة": "Document number",
  "تاريخ الانتهاء *": "Expiry date *",
  "التنبيه قبل الانتهاء بـ": "Remind before expiry by",
  "يوصل التنبيه للمدير والمشرف داخل جسر وعلى الجوال، ويعاد أسبوعياً حتى تجدّد الورقة وتحدّث تاريخها": "The reminder goes to the admin and supervisor in Jisr and on mobile, and repeats weekly until you renew the document and update its date",
  "جهة الإصدار، تكلفة التجديد، أي تفاصيل…": "Issuer, renewal cost, any details…",
  "جارٍ الحفظ…": "Saving…",
  "فشل التحميل": "Failed to load",
  "حذف «{name}» نهائياً؟": "Permanently delete “{name}”?",
  "فشل ربط الملف": "Failed to attach the file",
  "⚠️ {n} ورقة تحتاج انتباهك — مرتبة بالأقرب انتهاءً": "⚠️ {n} documents need your attention — sorted by soonest expiry",
  "كل الأوراق سارية ✓ — التنبيه يوصل للمدير والمشرف تلقائياً قبل الانتهاء": "All documents are valid ✓ — the admin and supervisor are reminded automatically before expiry",
  "جاري تحميل الأوراق…": "Loading documents…",
  "لا توجد أوراق مسجّلة": "No documents recorded",
  "أضف الرخصة التجارية وكل الأوراق الرسمية — وجسر ينبّهك قبل انتهاء أي منها": "Add the trade license and all official documents — Jisr will remind you before any of them expires",
  "تنبيه قبل {n} يوم": "Reminder {n} days before",
  "فتح الورقة ↗": "Open document ↗",
  "جارٍ الرفع…": "Uploading…",
  "استبدال الصورة": "Replace image",
  "＋ رفع صورة الورقة": "＋ Upload document image",
  "تعديل / تجديد": "Edit / Renew",
  "ليس لديك صلاحية على هذه الصفحة": "You don't have permission for this page",
  "قبل {n} د": "{n}m ago",
  "قبل {n} س": "{n}h ago",
  "قبل {n} يوم": "{n}d ago",
  "تعذر تحميل رابط التتبع": "Couldn't load the tracking link",
  "الرابط غير متاح": "Link unavailable",
  "جاري تحميل التتبع...": "Loading tracking...",
  "شعار {name}": "{name} logo",
  "مقدّم من": "Provided by",
  "رابط تتبع موثّق": "Verified tracking link",
  "تتبع مباشر": "Live tracking",
  "الجهاز لا يلتقط إشارة أقمار GPS حالياً — الموقع المعروض هو آخر موقع معروف": "The device currently has no GPS satellite signal — the location shown is the last known position",
  "التُقط": "captured",
  "، وقد تكون السيارة في مكان آخر.": ", and the vehicle may be elsewhere.",
  "حرارة الحمولة": "Cargo temperature",
  "النطاق المطلوب": "Required range",
  "قراءة العداد": "Odometer",
  "— (لا إشارة GPS)": "— (no GPS signal)",
  "المستأجر الحالي": "Current renter",
  "فتح موقع السيارة في Google Maps": "Open vehicle location in Google Maps",
  "تعذّر الدخول التلقائي": "Automatic sign-in failed",
  "تعذّر الدخول التلقائي — سجّل الدخول ببريدك وكلمة مرورك.": "Automatic sign-in failed — sign in with your email and password.",
  "جاري تحويلك لتسجيل الدخول…": "Redirecting you to sign in…",
  "تم الدفع بنجاح 🎉": "Payment successful 🎉",
  "جارٍ تجهيز حسابك وتسجيل دخولك…": "Setting up your account and signing you in…",
  "تحديد الكل كمقروء": "Mark all as read",
  "فتح التقويم": "Open calendar",
  "نماذج الشركة": "Company Forms",
  "الأوراق": "Documents",
  "المعاملات": "Transactions",
  "النماذج": "Forms",
  "معتمد": "Approved",
  "مرفوض": "Rejected",
  "الطلبات": "Orders",
  "أداء السائقين": "Driver performance",
  "الطلب": "Order",
  "من ← إلى": "From → To",
  "السائق / السيارة": "Driver / Vehicle",
  "الوصول": "Arrival",
  "الانتظار": "Waiting",
  "حدّد نقطة الاستلام": "Set pickup point",
  "حدّد الوجهة": "Set destination",
  "مُسندة": "Assigned",
  "نسبة القبول": "Acceptance rate",
  "ملغاة / لم يحضر": "Cancelled / No-show",
  "في الوقت": "On time",
  "مبكر": "Early",
  "متأخر (متوسط)": "Late (avg)",
  "متوسط الانتظار": "Avg wait",
  "خارج السياج": "Outside geofence",
  "فرق GPS": "GPS mismatch",
  "نطاق السياج (متر)": "Geofence radius (m)",
  "المسافة المسموحة لتسجيل الوصول من نقطة الاستلام/الوجهة": "Allowed distance from the pickup/destination point to check in",
  "مهلة الانتظار (دقيقة)": "Waiting grace (min)",
  "بعدها يُعلَّم الانتظار «تجاوز المهلة»": "After this, waiting is flagged “Grace exceeded”",
  "سماح التأخير (دقيقة)": "Late tolerance (min)",
  "الوصول بعد الموعد بأكثر منها = متأخر": "Arriving later than this after the scheduled time = Late",
  "حد التبكير (دقيقة)": "Early threshold (min)",
  "الوصول قبل الموعد بأكثر منها = مبكر": "Arriving earlier than this before the scheduled time = Early",
  "فرق GPS المسموح (متر)": "Allowed GPS mismatch (m)",
  "بين جوال السائق وجهاز السيارة — أكثر منه يُعلَّم للمراجعة": "Between the driver's phone and the vehicle device — more than this is flagged for review",
  "مجدول": "Scheduled",
  "مُسند — بانتظار القبول": "Assigned — awaiting acceptance",
  "قبِل السائق": "Driver accepted",
  "في الطريق للاستلام": "En route to pickup",
  "وصل — بانتظار الراكب": "Arrived — waiting for passenger",
  "الرحلة جارية": "Trip in progress",
  "وصل للوجهة": "At destination",
  "متأخر": "Late",
  "إنشاء الطلب": "Order created",
  "قبول السائق": "Driver accepted",
  "انطلق للاستلام": "Left for pickup",
  "وصول مُتحقَّق (السياج)": "Verified arrival (geofence)",
  "بدء الرحلة": "Trip started",
  "وصول للوجهة": "Arrived at destination",
  "تجاوز يدوي": "Manual override",
  "واتساب للعميل ✓": "WhatsApp to customer ✓",
  "واتساب للعميل ✗": "WhatsApp to customer ✗",
  "إشعار السائق ✓": "Driver notified ✓",
  "إشعار السائق ✗": "Driver notification ✗",
  "فرق بين جوال السائق وجهاز السيارة": "Mismatch between driver's phone and vehicle device",
  "محاولة وصول خارج السياج": "Check-in attempt outside geofence",
  "محاولة وصول للوجهة خارج السياج": "Destination arrival attempt outside geofence",
  "وصول بلا إحداثيات للنقطة": "Arrival with no coordinates for the point",
  "وصول للوجهة بلا إحداثيات": "Destination arrival with no coordinates",
  "تجاوز مهلة الانتظار": "Waiting grace exceeded",
  "تأكيد الحجز": "Booking confirmation",
  "السائق في الطريق + رابط التتبع": "Driver on the way + tracking link",
  "وصل السائق وينتظر": "Driver arrived and waiting",
  "تذكير انتظار (يدوي)": "Waiting reminder (manual)",
  "اكتمال الرحلة": "Trip completed",
  "بانتظار الاعتماد": "Awaiting approval",
  "جارٍ الإرسال": "Sending",
  "أُرجع للتعديل": "Returned for edits",
  "🧾 كشف العمولات": "🧾 Commission statement",
  "🚗 عمولات التوصيل": "🚗 Delivery commissions",
  "📈 أداء الموظفين": "📈 Staff performance",
  "📣 الإعلانات وCOR": "📣 Ads & COR",
  "⚙️ الموظفون": "⚙️ Employees",
  "قيمة العقود (د.ك)": "Contracts value (KWD)",
  "إجمالي العمولات (د.ك)": "Total commissions (KWD)",
  "عدد التوصيلات": "Deliveries",
  "إجمالي عمولات التوصيل (د.ك)": "Total delivery commissions (KWD)",
  "كود Drive8 (اختياري)": "Drive8 code (optional)",
};
export default EN_B5;
